export default "__VITE_ASSET__BNSC245A__"